"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderPhoneLink = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var renderPhoneLink = function renderPhoneLink(headerSettings, country) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "tertiary";
  var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "sm";
  var phoneNumber = headerSettings.utilityMenus.phoneNumber(country);
  return (0, jsx_runtime_1.jsx)(frontend_navigation_1.PhoneLink, {
    className: "phone-number",
    weight: "bold",
    type: type,
    size: size,
    formatter: phoneNumber.number,
    number: phoneNumber.value,
    dataTestId: "header-phone-link"
  });
};

exports.renderPhoneLink = renderPhoneLink;